export function generateTransactionId(studentId: string, date: string, type: string) {
  // Get date components
  const dateObj = new Date(date);
  const day = dateObj.getDate().toString().padStart(2, '0');
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
  const year = dateObj.getFullYear().toString().slice(-2);
  
  // Get type prefix
  const typePrefix = type.toUpperCase().slice(0, 3); // CAB, TUI, DAY
  
  // Generate random 6-character string
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let randomStr = '';
  for (let i = 0; i < 6; i++) {
    randomStr += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  // Format: TYPE-DDMMYY-RANDOM
  return `${typePrefix}-${day}${month}${year}-${randomStr}`;
}